import { makeStyles } from '@material-ui/core';
import { Colors, Typography } from '../../../shared/theme/styles.enum';

export const useStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    padding: '0px',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: '340px',
    width: '100%',
    padding: '0px',
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px 0px 0px 1rem',
    },
    '& .MuiDataGrid-cell': {
      padding: '0px 0px 0px 1.65rem',
    },
    '@media (max-width:768px)': {
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: 0,
      },
      '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
        padding: '0 4px !important',
        minWidth: '0 !important',
        maxWidth: 'none !important',
        width: 'auto !important',
        flex: '1 1 0 !important',
        overflow: 'hidden',
      },
      '& .MuiDataGrid-columnHeadersInner, & .MuiDataGrid-row': {
        display: 'flex !important',
        width: '100% !important',
        maxWidth: '100% !important',
      },
      '& .MuiDataGrid-virtualScrollerRenderZone, & .MuiDataGrid-virtualScrollerContent': {
        width: '100% !important',
      },
    },
  },
  '.MuiIconButton-root': {
    '& #postedDate-svg-icon': {
      backgroundColor: 'blue',
    },
  },
  header: {
    fontFamily: Typography.FontFamily2,
    fontSize: '1.25rem',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: Colors.Black,
    '@media (max-width:768px)': {
      fontSize: '0.75rem',
    },
  },
  cell: {
    fontFamily: Typography.FontFamily2,
    fontSize: '1.25rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: Colors.TextGray,
    '@media (max-width:768px)': {
      fontSize: '0.75rem',
    },
  },
  sortIcon: {
    width: 18,
    height: 16,
    marginBottom: 1,
  },
  renderHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 0px 0px 1rem',
  },
  renderHeaderAlignRight: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '-.5rem',
  },
  noRows: {
    textAlign: 'center',
    paddingTop: 50,
  },
});
